
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { routerNames } from "@/common/js/const";
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import conf from "./../../config/base.js";
import { setToken, getToken, getUrlKey} from "@/common/js/common";

export default {
name: routerNames.OrderInvoiceFollow,
components: {},
data() {
return {};
},
created() {},
activated() {
/*
该中间页面适配两种开票场景,本页面已启动需要登录requireAuth: true
1.商户加密好cpy参数,例如大润发
2.老商户不会加密cpy参数，需要将现有参数拼成cpy传至开票页面，例如宜家
*/
var $self = this;
const cpyParam = $self.$route.query.cpy;
if (cpyParam && cpyParam.length > 0) {
const merchant = $self.$route.query.br;
const user = $self.$route.query.openId;
$self.$router.replace({
path: "/orderInvoice/cfm",
query: { br: merchant, cpy: cpyParam, openId: user }
});
} else {
const queryStr = window.location.href;
var queryJSON = {
merchant: getUrlKey(queryStr, "m"),
or: getUrlKey(queryStr, "or"),
amount: getUrlKey(queryStr, "p"),
posDate: getUrlKey(queryStr, "d"),
storeCode: getUrlKey(queryStr, "b"),
mi: getUrlKey(queryStr, "mi")
};
const cpy =
"st=" +
queryJSON.storeCode +
"&or=" +
queryJSON.or +
"&am=" +
queryJSON.amount +
"&da=" +
queryJSON.posDate;
const params = {
data: cpy,
groupFlag: queryJSON.merchant,
type: "0"
};
$self.$webapi.hexEncryptOrDecrypt(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
let result = res.data.result;
let urlJson = {
br: queryJSON.merchant,
cpy: result,
mi: queryJSON.mi
};
$self.$router.replace({
path: "/orderInvoice/cfm",
query: urlJson
});
}
});
}
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {}
};
